import { Link } from 'react-router-dom';
import { useAuth, authUtils } from '@/hooks/useAuth';

export function Header() {
  const { user, profile, isAdmin } = useAuth();
  const isLoggedIn = !!user;

  return (
    <header className="border-b border-surface-border bg-surface">
      <div className="container-content">
        <div className="flex items-center justify-between h-12">
          <div className="flex items-center gap-4">
            <Link to="/" className="font-serif text-lg font-semibold text-text-primary no-underline hover:no-underline">
              Patent-Auktionsplattform
            </Link>
            {isLoggedIn && profile?.status === 'AKTIV' && (
              <nav className="hidden sm:flex gap-4 text-sm">
                <Link to="/dashboard" className="text-text-secondary hover:text-text-primary no-underline">
                  Dashboard
                </Link>
                {isAdmin && (
                  <Link to="/admin" className="text-text-secondary hover:text-text-primary no-underline">
                    Administration
                  </Link>
                )}
              </nav>
            )}
          </div>

          <div className="flex items-center gap-3 text-sm">
            {isLoggedIn ? (
              <>
                {profile?.status === 'PENDING_KYC' && (
                  <span className="text-warning text-xs">KYC ausstehend</span>
                )}
                <Link to="/profil" className="text-text-secondary hover:text-text-primary no-underline">
                  Profil
                </Link>
                <span className="text-text-muted">|</span>
                <button
                  onClick={() => authUtils.logout()}
                  className="text-text-secondary hover:text-text-primary no-underline bg-transparent border-0 cursor-pointer"
                >
                  Abmelden
                </button>
              </>
            ) : (
              <Link to="/anmelden" className="text-text-secondary hover:text-text-primary no-underline">
                Anmelden
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
